import { Spinner2, UnavailableContent } from '@el8/vital';
import React from 'react';

export const RestoreDeletedPatientsDialogUnavailableContent = ({
  loading,
  empty,
  error,
}: {
  loading: boolean;
  empty: boolean;
  error: boolean;
}): JSX.Element | null => {
  if (loading) {
    return (
      <UnavailableContent
        description="Retrieving deleted patients..."
        icon={<Spinner2 sizing="lg" />}
      />
    );
  }

  if (error) {
    return (
      <UnavailableContent
        description="There was an issue retrieving deleted patients. Please contact Elation Support if the issue persists."
        icon="unavailable"
      />
    );
  }

  if (empty) {
    return (
      <UnavailableContent description="No recently deleted patients found." icon="unavailable" />
    );
  }

  return null;
};
